import ReplyOptionButton from "@/ui/components/ReplyOptionButton";
import AppStoreTile from "@/ui/components/AppStoreTile";

export default function AppStoreTiles({ replyOptions, onButtonClick }) {
  // Sort replyOptions based on seq field
  const sortedReplyOptions = [...replyOptions].sort((a, b) => {
    // If both have seq, sort by seq
    if (a.seq !== undefined && b.seq !== undefined) {
      return a.seq - b.seq;
    }
    // If only a has seq, a comes first
    if (a.seq !== undefined) {
      return -1;
    }
    // If only b has seq, b comes first
    if (b.seq !== undefined) {
      return 1;
    }
    // If neither has seq, maintain original order
    return 0;
  });

  // Find the first item with seq
  const firstItem = sortedReplyOptions.find((option) => option.seq !== undefined);
  const isFirstItemStoreBadge = firstItem?.type === "store_badge";

  // Split options into store badges and other options
  const storeBadges = sortedReplyOptions.filter(
    (option) => option.type === "store_badge"
  );
  const otherOptions = sortedReplyOptions.filter(
    (option) => option.type !== "store_badge"
  );

  // Split other options into those with and without seq
  const otherOptionsWithSeq = otherOptions.filter((option) => option.seq !== undefined);
  const otherOptionsWithoutSeq = otherOptions.filter(
    (option) => option.seq === undefined
  );

  return (
    <div className="w-full flex flex-col items-center justify-center gap-2">
      {/* First row - either store badges or first seq item */}
      {isFirstItemStoreBadge
        ? // If first item is a store badge, show all store badges first
          storeBadges.length > 0 && (
            <div className="w-full flex flex-wrap items-center justify-center gap-2">
              {storeBadges.map((replyOption) => (
                <AppStoreTile
                  key={replyOption.selectionIntent}
                  replyOption={replyOption}
                />
              ))}
            </div>
          )
        : // If first item is not a store badge, show first seq item
          otherOptionsWithSeq.length > 0 && (
            <div className="w-full flex flex-wrap items-center justify-center gap-2">
              {otherOptionsWithSeq.map((replyOption) => (
                <ReplyOptionButton
                  key={replyOption.selectionIntent}
                  replyOption={replyOption}
                  handleButtonClick={onButtonClick}
                />
              ))}
            </div>
          )}

      {/* Second row - either store badges (if not first) or remaining seq items */}
      {isFirstItemStoreBadge
        ? // If store badges were first, show remaining seq items
          otherOptionsWithSeq.length > 0 && (
            <div className="w-full flex flex-wrap items-center justify-center gap-2">
              {otherOptionsWithSeq.map((replyOption) => (
                <ReplyOptionButton
                  key={replyOption.selectionIntent}
                  replyOption={replyOption}
                  handleButtonClick={onButtonClick}
                />
              ))}
            </div>
          )
        : // If store badges weren't first, show them now
          storeBadges.length > 0 && (
            <div className="w-full flex flex-wrap items-center justify-center gap-2">
              {storeBadges.map((replyOption) => (
                <AppStoreTile
                  key={replyOption.selectionIntent}
                  replyOption={replyOption}
                />
              ))}
            </div>
          )}

      {/* Last row - options without seq */}
      {otherOptionsWithoutSeq.length > 0 && (
        <div className="w-full flex flex-wrap items-center justify-center gap-2">
          {otherOptionsWithoutSeq.map((replyOption) => (
            <ReplyOptionButton
              key={replyOption.selectionIntent}
              replyOption={replyOption}
              handleButtonClick={onButtonClick}
            />
          ))}
        </div>
      )}
    </div>
  );
}
